import { Backdrop, LinearProgress } from '@mui/material';

function LinearProgressComponent() {
    return (
        <Backdrop
            sx={{
                color: '#fff',
                zIndex: (theme) => theme.zIndex.drawer + 1,
                backgroundColor: 'transparent',
                '& span': {
                    width: '100%',
                    height: '5px',
                    position: 'absolute'
                }
            }}
            open={true}
        >
            <LinearProgress style={{ top: 0 }} />
            <LinearProgress style={{ bottom: 0, transform: 'rotate(180deg)' }} />
        </Backdrop>
    );
}

export default LinearProgressComponent;
